/**
 * Helper to dynamically determine the API base URL depending on environment.
 */
export const getApiBaseUrl = () => {
  const envUrl = import.meta.env.VITE_API_URL;
  const isLocalFrontend =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1");

  // If envUrl is configured to localhost but the frontend is running on a deployed host,
  // fall back to relative path (or empty base) so requests go to host origin / proxy.
  if (envUrl && envUrl.includes("localhost") && !isLocalFrontend) {
    return "";
  }
  return envUrl || "";
};
